/* global updateImageCount, updateButtonByCheckAllRequiredValues */
import './form_validation';
import './item_image_counter';
import Rails from 'rails-ujs';

window.addEventListener('load', () => {
  updateImageCount();

  // 既に添付されていて戻ってきた要素を取得する
  const photos_cashed = Rails.$('.photo_cashed');
  // その要素に対して、それぞれ削除ボタンを追加する
  if (photos_cashed.length != 0) {
    photos_cashed.forEach((photo_cashed) => {
      const resetButton = document.createElement('div');
      resetButton.className = 'reset-button clickable reset-button-for-cashed';
      resetButton.innerHTML = '×';
      photo_cashed.appendChild(resetButton);
    });
  }

  const reset_buttons_for_cashed_photo = Rails.$('.reset-button-for-cashed');
  if (reset_buttons_for_cashed_photo.length != 0) {
    reset_buttons_for_cashed_photo.forEach((reset_button) => {
      reset_button.addEventListener('click', () => {
        // 各削除ボタンをクリックしたら、関連した要素を親要素から削除してもらう
        const li = reset_button.parentNode.parentNode;
        const wrapper = li.parentNode;
        li.parentNode.removeChild(li);
        // 1枚目キャッシュを削除した場合は has-primary を外して DragDrop を再表示する
        if (wrapper && wrapper.id === 'photos_cashed_wrapper_primary') {
          document.querySelector('.image-upload-primary')?.classList.remove('has-primary');
        }
        updateButtonByCheckAllRequiredValues();
        updateImageCount();
      });
    });
  }
});
